/**
 * DI-2-2 — the one distance function of the intake (story §4).
 *
 * Haversine on a sphere of the IUGG mean radius, R = 6 371 008.8 m — the same
 * function and constant DI-2-3's server side uses, kept in this one place.
 * A distance is bookkeeping, not the transformation (DI-D6 rev.).
 */
import type { LatLon } from "./types.js";

export const EARTH_RADIUS_M = 6_371_008.8;

const RAD = Math.PI / 180;

export function haversineM(a: LatLon, b: LatLon): number {
  const dLat = (b.lat - a.lat) * RAD;
  const dLon = (b.lon - a.lon) * RAD;
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(a.lat * RAD) * Math.cos(b.lat * RAD) * Math.sin(dLon / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.min(1, Math.sqrt(s)));
}
